import LogoIcon from '~/components/icons/LogoIcon';
import PageViewIcon from '~/components/icons/PageViewIcon';
import SalesforceIcon from '~/components/icons/SalesforceIcon';
import TraitIcon from '~/components/icons/TraitIcon';

// TODO: Decide if we want to index these and add them to search
const UNSEARCHABLE_COLUMNS = [
  'name',
  'last_visit_at',
  'last_visit_path',
  'person_count',
];

const reduceColumns = (allColumns) => {
  let results = [];

  if (allColumns.clearbit) {
    const searchableColumns = Object.entries(allColumns.clearbit).filter(
      ([value]) => !UNSEARCHABLE_COLUMNS.includes(value),
    );

    results.push({
      label: 'Clearbit',
      value: 'clearbit',
      parent: true,
      lastParent: true,
      adornment: <LogoIcon width={16} height={16} />,
      options: searchableColumns.map(([value, details]) => {
        return {
          value,
          details,
          adornment: <LogoIcon width={16} height={16} />,
          category: ['clearbit'],
        };
      }),
    });
  }

  if (allColumns.page_views) {
    results.push({
      label: 'Page View',
      value: 'event',
      parent: true,
      lastParent: true,
      adornment: <PageViewIcon width={16} height={16} />,
      options: allColumns.page_views.map((pageviewColumn) => ({
        category: ['event'],
        adornment: <PageViewIcon width={16} height={16} />,
        ...pageviewColumn,
      })),
    });
  }

  if (allColumns.traits) {
    results.push({
      label: 'Custom Traits',
      value: 'traits',
      parent: true,
      lastParent: true,
      adornment: <TraitIcon fill="#4779c6" width={14} height={12} />,
      options: Object.entries(allColumns.traits).map(([value, details]) => ({
        value,
        details,
        adornment: <TraitIcon fill="#4779c6" width={14} height={12} />,
        category: ['traits'],
      })),
    });
  }

  if (allColumns.salesforce) {
    if (allColumns.salesforce.opportunity) {
      results.push({
        label: 'Opportunities',
        value: 'opportunity',
        parent: true,
        lastParent: true,
        adornment: <SalesforceIcon height={16} width={16} />,
        options: Object.entries(allColumns.salesforce.opportunity).map(
          ([value, details]) => ({
            value,
            details,
            adornment: <SalesforceIcon height={16} width={16} />,
            category: ['salesforce', 'opportunity'],
          }),
        ),
      });
    }

    if (allColumns.salesforce.account) {
      results.push({
        label: 'Accounts',
        value: 'account',
        parent: true,
        lastParent: true,
        adornment: <SalesforceIcon height={16} width={16} />,
        options: Object.entries(allColumns.salesforce.account).map(
          ([value, details]) => ({
            value,
            details,
            adornment: <SalesforceIcon height={16} width={16} />,
            category: ['salesforce', 'account'],
          }),
        ),
      });
    }

    if (allColumns.salesforce.contact) {
      results.push({
        label: 'Contacts',
        value: 'contact',
        parent: true,
        lastParent: true,
        adornment: <SalesforceIcon height={16} width={16} />,
        options: Object.entries(allColumns.salesforce.contact).map(
          ([value, details]) => ({
            value,
            details,
            adornment: <SalesforceIcon height={16} width={16} />,
            category: ['salesforce', 'contact'],
          }),
        ),
      });
    }

    if (allColumns.salesforce.lead) {
      results.push({
        label: 'Leads',
        value: 'lead',
        parent: true,
        lastParent: true,
        adornment: <SalesforceIcon height={16} width={16} />,
        options: Object.entries(allColumns.salesforce.lead).map(
          ([value, details]) => ({
            value,
            details,
            adornment: <SalesforceIcon height={16} width={16} />,
            category: ['salesforce', 'lead'],
          }),
        ),
      });
    }
  }

  return results;
};

export default reduceColumns;
